var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClasses(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 53.308 53.308",
    style: {
      enableBackground: "new 0 0 53.308 53.308"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#436B1C"
    },
    d: "M39.685,3.179c-7.524,0-13.623,6.099-13.623,13.623c0,2.243,0.552,4.353,1.512,6.219 c1.496-0.565,3.11-0.888,4.804-0.888c5.281,0,9.851,3.011,12.111,7.404c5.15-1.944,8.819-6.905,8.819-12.735 C53.308,9.278,47.208,3.179,39.685,3.179z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D13834"
    },
    d: "M40.308,11.579c-1.657,0-3-0.94-3-2.1s1.343-2.1,3-2.1s3,0.94,3,2.1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#659C35"
    },
    d: "M40.308,12.579c-2.243,0-4-1.361-4-3.1s1.757-3.1,4-3.1s4,1.362,4,3.1c0,0.552-0.447,1-1,1 s-1-0.448-1-1c0-0.52-0.855-1.1-2-1.1s-2,0.581-2,1.1c0,0.519,0.855,1.1,2,1.1c0.553,0,1,0.448,1,1S40.86,12.579,40.308,12.579z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#659C35"
    },
    d: "M18.754,35.756c0-5.652,3.443-10.499,8.345-12.561c-0.927-6.622-6.598-11.723-13.475-11.723 C6.099,11.471,0,17.57,0,25.094c0,7.524,6.099,13.623,13.623,13.623c1.872,0,3.655-0.379,5.279-1.062 C18.814,37.033,18.754,36.402,18.754,35.756z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ED3F32"
    },
    d: "M14.308,20.979c-1.657,0-3-0.94-3-2.1s1.343-2.1,3-2.1s3,0.94,3,2.1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#436B1C"
    },
    d: "M14.308,21.979c-2.243,0-4-1.362-4-3.1s1.757-3.1,4-3.1s4,1.362,4,3.1c0,0.552-0.447,1-1,1 s-1-0.448-1-1c0-0.52-0.855-1.1-2-1.1s-2,0.581-2,1.1s0.855,1.1,2,1.1c0.553,0,1,0.448,1,1S14.86,21.979,14.308,21.979z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#88C057"
    },
    cx: 32.577,
    cy: 35.756,
    r: 14.373
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A4E869"
    },
    d: "M23.611,40.217c-0.412,0-0.798-0.257-0.942-0.667c-0.403-1.14-0.607-2.333-0.607-3.548 c0-0.552,0.447-1,1-1s1,0.448,1,1c0,0.987,0.166,1.957,0.492,2.882c0.185,0.521-0.089,1.092-0.609,1.276 C23.834,40.199,23.722,40.217,23.611,40.217z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A4E869"
    },
    d: "M32.683,46.625c-3.072,0-5.993-1.331-8.015-3.653c-0.363-0.417-0.319-1.048,0.097-1.411 c0.415-0.362,1.049-0.321,1.411,0.097c1.642,1.885,4.014,2.966,6.507,2.966c0.001,0,0.001,0,0.001,0c0.553,0,1.001,0.448,1.001,1 s-0.447,1-1,1C32.685,46.625,32.684,46.625,32.683,46.625z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ED3F32"
    },
    d: "M33.308,30.579c-1.657,0-3-0.94-3-2.1s1.343-2.1,3-2.1c1.657,0,3,0.94,3,2.1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#659C35"
    },
    d: "M33.308,31.579c-2.243,0-4-1.361-4-3.1s1.757-3.1,4-3.1s4,1.362,4,3.1c0,0.552-0.447,1-1,1 s-1-0.448-1-1c0-0.52-0.855-1.1-2-1.1s-2,0.581-2,1.1c0,0.519,0.855,1.1,2,1.1c0.553,0,1,0.448,1,1S33.86,31.579,33.308,31.579z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClasses);
export default __webpack_public_path__ + "static/media/classes.1bb24760d6ef7888b1a7125cd59a7a13.svg";
export { ForwardRef as ReactComponent };